import { useMemo } from 'react'

import { SelectedInstrument } from '../constants/instruments'
import { OrderQuoteParams, SetOrderQuoteParams } from '../constants/order'
import { SendRfqParams, SetRfqParams } from '../constants/rfqs'
import useOrderQueryParams from './useOrderQueryParams'
import useRfqQueryParams from './useRfqQueryParams'

type OrderParamProps = {
  isRfq: boolean
  orderParams: OrderQuoteParams | null
  setOrderParams: SetOrderQuoteParams
  rfqParams: SendRfqParams
  setRfqParams: SetRfqParams
  instruments: SelectedInstrument[]
}

export default function useOrderOrRfqQueryParams(): OrderParamProps {
  const [rfqParams, setRfqParams] = useRfqQueryParams()
  const [orderParams, setOrderParams] = useOrderQueryParams()

  const isRfq = rfqParams.legs.length ? true : false

  const instruments: SelectedInstrument[] = useMemo(() => {
    return isRfq
      ? rfqParams.legs.map((leg) => ({
          instrument_name: leg.instrument_name,
          direction: leg.direction,
        }))
      : orderParams
      ? [
          {
            instrument_name: orderParams.instrument_name,
            direction: orderParams.direction,
          },
        ]
      : []
  }, [isRfq, rfqParams, orderParams])

  return useMemo(
    () => ({
      isRfq,
      rfqParams,
      setRfqParams,
      orderParams,
      setOrderParams,
      instruments,
    }),
    [isRfq, instruments, rfqParams, setRfqParams, orderParams, setOrderParams]
  )
}
